export const HOME_PATH = '/dashboard/forecast';
export const MEET_EXPERT_PATH = '/dashboard/meet-an-expert';
export const HERO_EYEBROW = 'Next Best Money Moves';
export const LOADING_MESSAGE = 'Loading your quick richuels…';
export const ERROR_MESSAGE = "We couldn't load your quick richuels right now. Check your connection and try again.";
export const SEE_ALL_MONEY_MOVES_PATH = '/dashboard/tracks/your-quick-richuels';
